import { FormProvider } from "react-hook-form";
import { Input } from "@/components/ui/form";
import { Button } from "@/components/ui/button";

export const ChangePasswordForm = ({
    methods,
    onSubmit,
    isPending = false,
}) => {
    return (
        <FormProvider {...methods}>
            <form
                onSubmit={methods.handleSubmit(onSubmit)}
                className="col-span-full grid max-w-6xl grid-cols-subgrid gap-y-6 md:gap-x-8 md:gap-y-3 lg:col-span-6"
            >
                <div className="col-span-full grid grid-cols-subgrid gap-y-4 lg:col-span-6">
                    <div className="col-span-full md:col-span-4 lg:col-span-3">
                        <Input
                            type="password"
                            name="password"
                            label="Password"
                            placeholder="••••••••"
                        />
                    </div>
                    <div className="col-span-full md:col-span-4 md:mt-7 lg:col-span-3">
                        <Button
                            type="submit"
                            variant="primary"
                            id="confirm-button"
                            disabled={isPending}
                        >
                            Confirm
                        </Button>
                    </div>
                </div>
            </form>
        </FormProvider>
    );
};
